
















import {
  defineComponent,
  onBeforeMount,
  onMounted,
  watch,
} from "@vue/composition-api"
import { useAppBar } from "@/app/reactive/app-bar.state"
import { useBrowser } from "@/app/reactive/browser.state"
import ErrorSection from "@/app/components/common/ErrorSection.vue"
import { useFindOneFacility } from "@/app/reactive/facility"
import { useCancelBooking, useFindOneBooking } from "@/app/reactive/booking"

export default defineComponent({
  components: {
    ErrorSection,
  },
  setup(props, { root }) {
    const AppBar = useAppBar()
    const Browser = useBrowser()

    const {
      findOneFacility,
      facility,
      isFacilityPending,
    } = useFindOneFacility()

    const { isCancelBookingPending, cancelBooking } = useCancelBooking()

    const { booking } = useFindOneBooking()

    function finishReservation() {
      if (!isCancelBookingPending.value) {
        cancelBooking(booking)
      }
    }

    watch(facility, facility => {
      AppBar.setTitle(facility?.name ?? "Parcandi")
    })

    onBeforeMount(() => {
      findOneFacility(root.$route.params.id)
    })

    onMounted(() => {
      AppBar.setTitle(null)
      AppBar.setHasBackButton(false)
      Browser.setHasUnsavedData(false)
    })

    return {
      isFacilityPending,
      facility,
      finishReservation,
    }
  },
})
